// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb-container {
  width: 100%;
  position: relative;
}
.breadcrumb-container__content {
  display: flex;
  align-items: center;
  gap: 8px;
  -webkit-user-select: none;
  user-select: none;
}
.breadcrumb-container__content--read-only {
  font-weight: 500;
  gap: 2px;
}
.breadcrumb-container__content--read-only .breadcrumb-container__content__item {
  gap: 4px;
  color: var(--m-subtle-xxxbolder);
}
.breadcrumb-container__content__item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--m-text-muted);
}
.breadcrumb-container__content__item > span {
  display: flex;
}
.breadcrumb-container__content__item--label, .breadcrumb-container__content__item--truncated-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 250px;
  vertical-align: middle;
  cursor: default;
}
.breadcrumb-container__content__item--label:not(.breadcrumb-container__content__item--last):hover, .breadcrumb-container__content__item--truncated-label:not(.breadcrumb-container__content__item--last):hover {
  text-decoration-line: underline;
  cursor: pointer;
}
.breadcrumb-container__content__item--separator {
  cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Breadcrumbs/style.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EAGQ,iBAAA;AAChB;AACQ;EACI,gBAAA;EACA,QAAA;AACZ;AACY;EACI,QAAA;EACA,gCAAA;AAChB;AAGQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;AADZ;AAGY;EACI,aAAA;AADhB;AAIY;EAEI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAHhB;AAKgB;EAEI,+BAAA;EACA,eAAA;AAHpB;AAOY;EACI,eAAA;AALhB","sourcesContent":[".breadcrumb-container {\n    width: 100%;\n    position: relative;\n\n    &__content {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        -webkit-user-select: none;\n           -moz-user-select: none;\n            -ms-user-select: none;\n                user-select: none;\n        \n        &--read-only {\n            font-weight: 500;\n            gap: 2px;\n            \n            .breadcrumb-container__content__item {\n                gap: 4px;\n                color: var(--m-subtle-xxxbolder);\n            }\n        }\n        \n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            color: var(--m-text-muted);\n\n            > span {\n                display: flex;\n            }\n\n            &--label,\n            &--truncated-label {\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                display: inline-block;\n                max-width: 250px;\n                vertical-align: middle;\n                cursor: default;\n\n                &:not(.breadcrumb-container__content__item--last):hover {\n                    -webkit-text-decoration-line: underline;\n                    text-decoration-line: underline;\n                    cursor: pointer;\n                }\n            }\n\n            &--separator {\n                cursor: default;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
